import styled from 'styled-components/macro';
import px2vw from '../../utils/px2vw'

export const ContactInfor = styled.div`
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => { 
        return props.theme.mobCommonTitleFontSize?props.theme.mobCommonTitleFontSize:px2vw(20)
    }};  
    font-weight: 700;
    line-height:  ${props => { 
        return props.theme.pLineHeight?props.theme.pLineHeight:px2vw(24)
    }};  
    letter-spacing: 0px;
    padding-left: ${px2vw(12)};
     @media only screen and (max-width: 425px) {
        padding-top : 2%;
        padding-bottom : 5%;
        padding-left : 5%;
    }
`;

export const ContactMenu = styled.div`
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => { 
        return props.theme.mobCommonTitleFontSize?props.theme.mobCommonTitleFontSize:px2vw(20)
    }};  
    font-weight: 500;
    line-height:  ${props => { 
        return props.theme.pLineHeight?props.theme.pLineHeight:px2vw(36)
    }};  
    letter-spacing: 0px;
    padding-bottom: ${px2vw(24)};
    @media only screen and (max-width: 425px) {
        padding-top : 5%;
        padding-bottom : 5%;
    }
`;

export const AboutAndWork = styled.div`
    padding-bottom: ${px2vw(24)};
    display: flex;
    flex-direction: row-reverse;
    @media only screen and (max-width: 425px) {
        display: none;
    }
`;

export const ContactCol = styled.div`
display: flex;
flex-direction: column;
@media only screen and (max-width: 425px) {
        width: 100%;
    }
`;

export const AboutAndWorkP = styled.p`
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => { 
        return props.theme.subHeaderFontSize?props.theme.subHeaderFontSize:px2vw(16)
    }};  
    font-weight: 500;    
    line-height:  ${px2vw(24)};  
    letter-spacing: 0px;
    font-style: normal;
    padding-left: 56px; 
    transition: 0.3s;
    &:hover {
        transform: translateY(-3px); 
    }
    a {
        color: #0A2540;
    }
`;

export const MapHodler = styled.img`
    height:  100%;
    width: 100%;
`;


export const MapHodlerDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    position: relative;
`;

export const PoweredBy = styled.div`
  position: absolute;
  font-family: ${props => props.theme.fontFamily};
  bottom: 5%;
  left: 0px;
  font-size: ${px2vw(16)};  
  @media only screen and (max-width: 770px) {
    font-size: ${px2vw(36)}; 
    }
`;
